export default {
  actions: {
    REGISTRATION: 'REGISTRATION',
    LOGIN_OTP: 'LOGIN_OTP',
    CONFIRM_REGISTRATION_OTP: 'CONFIRM_REGISTRATION_OTP'
  }
}
